export const formatEmailInput = (value: string) =>
  value.replace(/\s+/g, "").toLowerCase();

export const getEmailValidationError = (value: string) => {
  if (!value) return "Enter your email address.";
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
    ? ""
    : "Enter a valid email address.";
};
